import { Button } from "@blueprintjs/core";
import classNames from "classnames";
import { forwardRef, PropsWithChildren } from "react";
import { TextLinkButton } from "../common/TextLinkButton";
import css from "./SelectionBar.module.scss";

export const SelectionBar = forwardRef<
    HTMLDivElement,
    PropsWithChildren<{
        selectedCount: number;
        emptyLabel: string;
        onClear: () => void;
        onCancel?: () => void;
        itemName: string;
        className?: string;
    }>
>(function SelectionBar(
    {
        selectedCount,
        emptyLabel,
        onClear,
        onCancel,
        itemName,
        className,
        children
    },
    ref
) {
    const hasSelection = selectedCount > 0;

    return (
        <div ref={ref} className={classNames(css["SelectionBar"], className)}>
            <div className={css["SelectionBar-status"]}>
                <span className="bp5-text-muted">
                    {hasSelection
                        ? `${selectedCount} ${itemName}${
                              selectedCount === 1 ? "" : "s"
                          } selected`
                        : emptyLabel}
                </span>
                {hasSelection && (
                    <TextLinkButton text="Clear" onClick={onClear} />
                )}
            </div>
            <div className={css["SelectionBar-actions"]}>
                {onCancel && <Button text="Cancel" onClick={onCancel} />}
                {children}
            </div>
        </div>
    );
});
